import { Country } from 'library/ts/model/enums/geo/Country';
import { EmbedContext } from 'tag/ts/tag/model/enums/EmbedContext';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { EmbedDeviceVersion } from 'tag/ts/tag/model/type/embed/EmbedDeviceVersion';
import { EmbedPlatform } from 'tag/ts/tag/model/type/embed/EmbedPlatform';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
export class ParamsVO {
    SYSTEM = {
        embedType: EmbedType.DESKTOP,
        platform: EmbedPlatform.DESKTOP,
        device: EmbedDevice.DESKTOP,
        deviceVersion: EmbedDeviceVersion.DESKTOP['2017']
    };
    TAG = {
        uuid: undefined,
        embedContext: EmbedContext.INLINE,
        callback: undefined,
        config: {
            tag: undefined,
            skin: undefined
        },
        container: undefined,
        background: {
            smartTag: {
                color: 'black'
            },
            content: {
                color: 'black'
            },
            overlay: {
                color: 'black'
            }
        },
        namespace: undefined,
        playerOptions: undefined,
        errorPanel: true,
        loadingAnimation: true,
        loadingAnimationConfig: {
            timeoutForMessage: 5000,
            timeoutMessage: 'Optimizing your video playback experience',
            backgroundImage: {
                enabled: false,
                imageURL: undefined,
                overlayOpacity: 0.6
            },
            spinner: {
                enabled: true
            },
            fadeIn: {
                enabled: false,
                duration: 300
            }
        },
        platformSupportCheck: true,
        trackingDisabled: false
    };
    AD = {
        AB: {
            method: undefined,
            interval: 5000,
            delay: 7000
        },
        IMA: {
            iu: undefined
        },
        SETTINGS: undefined,
        PAUSE: undefined,
        SDK: {
            preload: true
        },
        LINEAR_AD_TRACKING: undefined,
        CONTEXT: undefined
    };
    CONTENT = {
        apiMetadata: undefined,
        millstone: undefined,
        assetURL: undefined,
        autoplay: false,
        brandLogoUrl: undefined,
        contentId: undefined,
        country: Country.US,
        drm: undefined,
        globalResumeTime: NaN,
        isLive: false,
        locale: 'en-us',
        partner: 'pplus',
        pid: undefined,
        resource: undefined,
        daiFailover: [EmbedType.DESKTOP],
        loadingAnimationBackgroundImageURL: undefined
    };
    SKIN = {
        cp: undefined,
        fch: undefined,
        enabled: true,
        defaultSkin: false,
        markersVisible: true,
        liveLogoURL: undefined,
        liveStreamTimeout: NaN,
        liveStreamTimeoutCountdown: NaN,
        liveCountdownTemplate: undefined,
        vodTimeoutPlaybackTimeoutEpisode: NaN,
        vodTimeoutPlaybackTimeoutMovie: NaN,
        vodTimeoutInactivityTimeoutPrompt: NaN,
        playbackEvents: undefined,
        onStart: {
            ccVisible: undefined,
            controlsVisible: undefined,
            mute: undefined
        },
        brandLogoUrl: undefined
    };
    USER = {
        userId: undefined,
        profileId: undefined,
        userStatus: 'anon',
        bundleStatus: '',
        pinGate: false,
        mvpdId: undefined,
        usPrivacy: undefined,
        packageSource: undefined
    };
    CONTEXT = {
        metadata: undefined
    };
}
